import { render, staticRenderFns } from "./FinalizePage.vue?vue&type=template&id=57df89fd&scoped=true&"
import script from "./FinalizePage.vue?vue&type=script&lang=js&"
export * from "./FinalizePage.vue?vue&type=script&lang=js&"
import style0 from "./FinalizePage.vue?vue&type=style&index=0&id=57df89fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df89fd",
  null
  
)

export default component.exports